// extracted by mini-css-extract-plugin
module.exports = {"beaucoupDeResultats":"BeaucoupDeResultats_beaucoupDeResultats__1ti3a","controls":"BeaucoupDeResultats_controls__1u7bE","btn":"BeaucoupDeResultats_btn__Wpqir"};